import { AppButton, AppSelectBox } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useStatus from 'hooks/useStatus';
import { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

function ChooseSubjectModal({ modalConfig = {}, closeModal }) {
  const history = useHistory();
  const [subject, handleSubject] = useStatus(null);
  function navigateChapter(id, subjectId) {
    if (subjectId) {
      history.push(`/manage/classes/${id}/subjects/${subjectId}/chapters`);
    }
  }

  function clearData() {
    handleSubject(null);
  }
  useEffect(() => {
    clearData();
  }, [modalConfig]);

  return (
    <AppModal open={modalConfig.show} closeModal={closeModal} size="sm">
      <AppModalHeader>Choose Subject</AppModalHeader>
      <AppModalBody>
        <AppSelectBox
          labelProps={{ label: 'Subject' }}
          selectProps={{
            onChange: (event) => handleSubject(event.target.value),
          }}
        >
          <option value="">Choose</option>
          {modalConfig?.data?.subjects?.map((option) => {
            return (
              <option key={option.subject._id} value={option.subject._id}>
                {option.subject.name}
              </option>
            );
          })}
        </AppSelectBox>
      </AppModalBody>
      <AppModalFooter>
        <AppButton
          variantClass="btn btn-success mx-4"
          onClick={() => navigateChapter(modalConfig?.data?.id, subject)}
        >
          Choose
        </AppButton>
      </AppModalFooter>
    </AppModal>
  );
}

export default ChooseSubjectModal;
